import { OMenuElement } from "../elements/OMenuElement";

export class ISlice extends OMenuElement {}
